import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from '../core/pipes/safe-html.pipe';
import { TimeFormatPipe } from '../core/pipes/time-format.pipe';
import { SharedModule } from '../shared/shared.module';
import { AdminLayoutComponent } from './ui-components/admin-layout/admin-layout.component';
import { LinkbarComponent } from './ui-components/template-parts/linkbar/linkbar.component';
import { PageFooterComponent } from './ui-components/template-parts/page-footer/page-footer.component';
import { PageHeaderComponent } from './ui-components/template-parts/page-header/page-header.component';
import { SidebarFooterComponent } from './ui-components/template-parts/sidebar/sidebar-footer/sidebar-footer.component';
import { SidebarComponent } from './ui-components/template-parts/sidebar/sidebar.component';

@NgModule({
  declarations: [
    SidebarFooterComponent,
    LinkbarComponent,
    SidebarComponent,
    AdminLayoutComponent,
    PageFooterComponent,
    PageHeaderComponent,
  ],
  imports: [CommonModule, SharedModule, SafeHtmlPipe, TimeFormatPipe],
  exports: [PageHeaderComponent, PageFooterComponent],
})
export class AdminLayoutModule {}
